module.exports = __webpack_public_path__ + "static/media/renewal_comment_bell.e05ed056.png";